import { render, staticRenderFns } from "./ModalKasKecilUploadReceipt.vue?vue&type=template&id=bf96c196&scoped=true&"
import script from "./ModalKasKecilUploadReceipt.vue?vue&type=script&lang=js&"
export * from "./ModalKasKecilUploadReceipt.vue?vue&type=script&lang=js&"
import style0 from "./ModalKasKecilUploadReceipt.vue?vue&type=style&index=0&id=bf96c196&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf96c196",
  null
  
)

export default component.exports